import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import AppRouteEnum from '../../shared/enums/app-route.enum';

const getDefaultPath = (): string => AppRouteEnum.Aida;

const routes: Routes = [
    {
        path: '**',
        redirectTo: getDefaultPath(),
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DashboardRoutingModule {}
